import { register } from "@/api/users";
import Card from "@/components/Card";
import PasswordInput from "@/components/form/PasswordInput";
import TextInput from "@/components/form/TextInput";
import UserRoleDropdown from "@/components/form/UserRoleDropdown";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { RoleType, User } from "@/models/user.model";
import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function RegisterForm() {
  const navigate = useNavigate();

  const { toast } = useToast();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState<RoleType>(RoleType.STAFF);
  const [err, setErr] = useState<string>("");
  const [pw, setPw] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isValid()) {
      return;
    }

    try {
      const registered = await register(fullName, email, role, pw);
      if (registered) {
        console.log("User created", registered);
        setErr("");
        toast({
          title: "User created!",
          description: `An account for ${registered.fullName} has been successfully created`,
        });

        clearForm();
        if (registered.role === RoleType.ADMIN) {
          navigate("/admin/users");
        } else {
          navigate(`/admin/onboard/${registered.id}`);
        }
      } else {
        toast({
          title: "An error occurred",
          description: "Please try again",
          variant: "destructive",
        });
      }
    } catch (err: any) {
      console.log(err);
      toast({
        title: "An error occurred",
        description: `${err.response.data.message}` || "Please try again",
        variant: "destructive",
      });
    }
    // setNewUser(registered);
    // navigate("/admin/users");
    // setPage((prev) => prev + 1);
  };

  const isValid = () => {
    if (
      fullName.length === 0 ||
      email.length === 0 ||
      pw.length === 0
    ) {
      setErr("All fields are required.");
      return false;
    }
    if (/^[a-zA-Z0-9._%+-]+@xp\.com\.sg$/.test(email) === false) {
      setErr("Email must be a valid @xp.com.sg email.");
      return false;
    }
    setErr("");
    return true;
  };
  const clearForm = () => {
    setFullName("");
    setEmail("");
    setRole(RoleType.STAFF);
    setPw("");
    setErr("");
  };

  useEffect(() => {
    isValid();
  }, [role, fullName, email, pw]);
  return (
    <form className="w-full h-full flex flex-col gap-4" onSubmit={handleSubmit}>
      <div className="flex flex-col mb-2">
        <UserRoleDropdown selectedRole={role} setSelectedRole={setRole} />
      </div>
      <div className="flex gap-2 justify-between">

        <TextInput
          type="text"
          label="Full Name"
          value={fullName}
          setValue={setFullName}
        />
      </div>

      <TextInput type="email" label="Email" value={email} setValue={setEmail} />
      {/* <TextInput type="password" label="Password" value={pw} setValue={setPw} /> */}
      <PasswordInput value={pw} setValue={setPw} label="Password" />
      <div className="text-sm italic text-gray-500">
        Set a temporary password for the new employee. They will be able to
        change this password on their own.
      </div>

      {err && <div className="text-red-500 text-sm">{err}</div>}
      <div className="flex w-full mt-2 justify-between">
        <Button variant="outline" type="button" onClick={() => navigate("/admin/users")}>Cancel</Button>
        <Button
          disabled={
            fullName.length === 0 ||
            email.length === 0 ||
            pw.length === 0
          }
        >
          Create account
        </Button>
      </div>
    </form>
  );
}
export default RegisterForm;
